export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6642.1abae1a6.jpg";